import { IXhrConfig } from './IHlsJsExtended';

import { userAgentUtil } from '../player/UserAgentUtil';

export const MULTICAST_MAX_RETRIES: number = userAgentUtil.isSafariMac ? 10 : 5;
const PARMS_REGEX = /(?<parm1>\w{32})(?<parm2>\d+)(-(?<parm3>\w{32})(?<parm4>\d+))*/;

let disabledManifestRewriteHeader = {
	apply: false,
	value: 'false'
};

function getQueryParam(src: string, param: string): string {
	const [, queryParams] = src.split('?');

	if (typeof queryParams === 'string') {
		const paramsObj = queryParams
			.split('&')
			.reduce((a, c) => {
				const [name, value] = c.split('=');
				a[name] = value;

				return a;
			}, {});

		return paramsObj[param];
	}

	return null;
}

export function setDisabledManifestRewriteHeaderFlag(flag: { apply: boolean, value: string }): void {
	disabledManifestRewriteHeader = flag;
}

export function multicastXhrConfig(src: string): Partial<IXhrConfig> {
	const ip = getQueryParam(src, 'ip');
	const port = getQueryParam(src, 'port');
	const parms = getQueryParam(src, 'parms');
	const settings = getQueryParam(src, 'settings');

	const additionalHeaders: { ip: string, port: string, settings?: any, disableRewriteManifest?: string } = {
		ip,
		port
	};

	if (settings) {
		additionalHeaders.settings = settings;
	}

	if (disabledManifestRewriteHeader.apply) {
		additionalHeaders.disableRewriteManifest = disabledManifestRewriteHeader.value;
	}

	if (!parms) {
		return {
			additionalHeaders
		};
	}

	return {
		additionalHeaders: {
			...additionalHeaders,
			settings: parseEncryptionKeys(parms)
		}
	};
}

export function removeQueryStr(src: string): string {
	return src.split('?')[0];
}

function parseEncryptionKeys(parms: string): string {
	if (!parms) {
		return;
	}
	const encrptionSettings = [];
	const encParms = PARMS_REGEX.exec(parms).groups;
	const encParmsLen = Object.keys(encParms).length;
	if (!encParmsLen) {
		return;
	}

	for (let i = 1; i < encParmsLen; i+=2) {
		if (encParms[`parm${i}`]) {
			encrptionSettings.push({ parm1: encParms[`parm${i}`], parm2: +encParms[`parm${i+1}`] });
		}
	}
	return JSON.stringify({ encKeys: encrptionSettings });
}
